module.exports = __webpack_public_path__ + "static/media/doubts.ccfabe71.svg";